const oneClickBuyBasket = function () {
    const name = 'one_click_buy_basket';

    if (window.matchMedia('(min-width:992px)').matches) {
        const fastOrderBtn = document.querySelector('.fast_order');

        if (fastOrderBtn && !fastOrderBtn.classList.contains('clicked')) {
            document.querySelectorAll('.fast_order').forEach((el) => el.classList.add('clicked'));

            document.querySelectorAll('.' + name + '_frame, .jqmOverlay').forEach((el) => el.remove());

            const overlay = document.createElement('div');
            overlay.className = 'jqmOverlay';
            overlay.style.cssText =
                'position:fixed; top:0; left:0; width:100%; height:100%; background-color:#000; opacity:0.5; z-index:2999;';
            document.body.appendChild(overlay);

            const frame = document.createElement('div');
            frame.className = name + '_frame popup';
            frame.style.cssText = 'position:fixed; z-index:3000; display:none;';
            document.body.appendChild(frame);

            const wElement = typeof window.jQuery !== 'undefined' ? window.jQuery(frame) : frame;
            const oElement = typeof window.jQuery !== 'undefined' ? window.jQuery(overlay) : overlay;
            const hash = {w: wElement, o: oElement};

            const closeModal = () => {
                if (typeof window.onHidejqm === 'function') {
                    window.onHidejqm(name, hash);
                }
                frame.remove();
                overlay.remove();
                document.querySelectorAll('.fast_order').forEach((el) => el.classList.remove('clicked'));
            };

            overlay.addEventListener('click', closeModal);

            const siteDir = window.arNextOptions ? window.arNextOptions['SITE_DIR'] : '/';
            const url = siteDir + 'ajax/one_click_buy_basket.php';

            fetch(url)
                .then((response) => {
                    if (!response.ok) throw new Error('Ошибка при загрузке формы');
                    return response.text();
                })
                .then((html) => {
                    frame.innerHTML = html;
                    frame.style.display = 'block';

                    const closeBtn = frame.querySelector('.jqmClose');
                    if (closeBtn) {
                        closeBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            closeModal();
                        });
                    }

                    if (typeof window.onLoadjqm === 'function') {
                        window.onLoadjqm(name, hash);
                    }
                })
                .catch((error) => {
                    console.error('Ошибка:', error);
                    closeModal();
                });
        }
    } else {
        const siteDir = window.arNextOptions ? window.arNextOptions['SITE_DIR'] : '/';
        let script = siteDir + 'form/?name=' + name + '&form_id=ocb&path=' + window.location.pathname + '&buy_basket=y';
        window.location.href = script;
    }
};

document.addEventListener('click', function (event) {
    const btn = event.target.closest('.fast_order');
    if (btn) {
        event.preventDefault();
        oneClickBuyBasket();
    }
});
